module.exports = __webpack_public_path__ + "static/media/visual-design.535b5274.svg";